import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const usersModule = {
  namespaced: true,
  state: {
    userses: null,
    users: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default usersModule;
